




































































import { Vue, Component, Prop } from 'vue-property-decorator';
import IntegrationFieldValueModel from '@/models/crm/integration-field-value.model';

@Component
export default class CrmIntegrationFields extends Vue {
  @Prop({ default: () => [] })
  readonly fields!: IntegrationFieldValueModel[];

  @Prop({ default: '' })
  readonly title!: string;

  @Prop({ default: 'mdi-form-textbox' })
  readonly icon!: string;

  @Prop({ default: false })
  readonly readonly!: boolean;

  @Prop({ default: false })
  readonly loading!: boolean;

  @Prop({ default: false })
  readonly flat!: boolean;

  @Prop({ default: false })
  readonly disabled!: boolean;

  @Prop({ default: '' })
  readonly emptyMessage!: string;

  get displayFields(): IntegrationFieldValueModel[] {
    return (this.fields || []).filter((f) => {
      if (f.valor === null || f.valor === undefined) return false;
      return String(f.valor).replace(/\s/g, '').length > 0;
    });
  }

  onValueInput(field: IntegrationFieldValueModel, value: string): void {
    const updated = (this.fields || []).map((f) => (f.id === field.id || f.key === field.key
      ? { ...f, valor: value }
      : f));
    this.$emit('input', updated);
  }
}
